import { VIDEO_SPEED_FORM_STATE_KEY } from './ea-video-player.utils';

import { INgxsFormStateValues } from 'src/app/states/store.models';

export interface IEaVideoPlayerStateModel {
    /** The timestamp that is currently present in the route query params */
    queryParamsTimestamp: string | undefined;
    /** The event ID that is currently present in the route query params */
    queryParamsEventId: string | undefined;
    /** When a new video is selected this will be true when it's ready to be played */
    videoCanBePlayed: boolean;
    /** When true the video is muted */
    videoMuted: boolean;
    /** When true the video is playing. Setting this to true will play the video */
    videoPlaying: boolean;
    /** The form that reacts to the video speed select */
    [VIDEO_SPEED_FORM_STATE_KEY]: INgxsFormStateValues<IEaVideoPlayerSpeedForm>;
    /** Any errors from video playback will be stored here */
    videoPlaybackError: string | undefined;
    /** The current playback position of the video, in seconds. Updated as the video plays/seeks. */
    currentVideoTimeSeconds: number;
}

/** The values of the video speed select form */
export interface IEaVideoPlayerSpeedForm {
    videoSpeed: number;
}

/** The units used for the time skip buttons */
export enum IEaVideoPlayerTimeSkipUnit {
    SECONDS = 'seconds',
    FRAMES = 'frames'
}

/** The directions for the time skip buttons */
export enum IEaVideoPlayerTimeSkipDirection {
    FORWARD = 'forward',
    BACKWARD = 'backward'
}

/** Configuration model for the time skip buttons (e.g. -1s, -15s, +1m) */
export interface IEaVideoPlayerSkipButtonConfig {
    translationString: string;
    timeLabel: string;
    timeAmount: number;
    timeUnits: IEaVideoPlayerTimeSkipUnit;
}

/** The hotkeys for the video player */
export enum EaVideoPlayerKeybindings {
    MUTE = 'mute',
    PLAY = 'play',
    PAUSE = 'pause',
    SPEED_1 = 'speed-1',
    SPEED_2 = 'speed-2',
    SPEED_3 = 'speed-3',
    SPEED_4 = 'speed-4',
    SPEED_5 = 'speed-5',
    FORWARD_1_FRAME = 'forward-1-frame',
    FORWARD_1_SECOND = 'forward-1-second',
    BACKWARD_1_FRAME = 'backward-1-frame',
    BACKWARD_1_SECOND = 'backward-1-second',
}
